import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Typography from '@material-ui/core/Typography';
import makeStyles from '@material-ui/core/styles/makeStyles'
import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import loadable from '@loadable/component'
const RamiHeadSmileSvg = loadable(() => import('../svg/RamiHeadSmileSvg'))

const useStyles = makeStyles((theme) => ({
    cont: {
        border: `15px solid ${theme.palette.secondary.main}`,
        borderRadius: 4,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '60px !important',
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            padding: '20px !important', 
        },
    },
    rami: {
        width: 200,
        minWidth: 200,
        minHeight: 200,
        height: 200,
        [theme.breakpoints.down('xs')]: {
            width: 100,
            minWidth: 100,
            minHeight: 100,
            height: 100,
        },
    },
    text: {
        color: theme.palette.primary.main,
        fontSize: 30,
        fontWeight: 550,
        marginLeft: 40,
        '& .edge': {
            color: theme.palette.secondary.orange
        },
        [theme.breakpoints.down('sm')]: {
            marginLeft: 0,
            marginTop: 40,
        },
        [theme.breakpoints.down('xs')]: {
            fontSize: 20,
            marginTop: 20,
        },
    }
}))

const IEinfoComponent = (props) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const [openIE, setOpenIE] = useState(true);
    const handleClose = useCallback(() => {
        setOpenIE(false);
    }, [])

    useEffect(() => {
        const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
        setOpenIE(isIE11);
        // setOpenIE(true);
    }, [])
    return (
        // t('ie.content')
        <Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={openIE} maxWidth='md' >
            <DialogContent className={classes.cont}>
                <RamiHeadSmileSvg className={classes.rami} />
                <Typography dangerouslySetInnerHTML={{ __html: t('ie.content') }} className={classes.text} />
            </DialogContent>

        </Dialog>
    )
}


export default React.memo(IEinfoComponent);